import { Component, OnInit, AfterViewInit, Inject, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
  


import { IZipCode, ZipCodeApiService } from '@ebb-v2/ebb-integration';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { cloneDeep } from 'lodash';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';

@Component({
    selector: 'ebb-portal-dialog-zipcode',
    templateUrl: './dialog-zipcode.component.html',
    standalone: false
})
export class DialogZipcodeComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ['select',  'name',  'city','county',];

  public title = 'ADD SERVICE ZIP CODES';

  public listZip: IZipCode[] = [];
  public listZipToAdd: IZipCode[] = [];
  public listZip25miles: IZipCode[] = [];
  public listZipSelected: IZipCode[] = [];
  public listSearch: IZipCode[] = [];

  public dataSourceTable = new MatTableDataSource<IZipCode>([]);
  public selection = new SelectionModel<IZipCode>(true, []);
  public dataResultsLength = 0;
  //public displayedColumns: string[] = ['checkbox', 'zipCode', 'city'];
  public tablePageSizeOptions: number[] = [5, 10, 25];
  public formSearch: FormGroup;

  public waitForListingToShow = true;
  public noSearchResults = false;
  public addButtonDisabled = true; 
  @ViewChild(MatPaginator) dataPaginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  constructor(
    public readonly dialogRef: MatDialogRef<DialogZipcodeComponent>,
    public readonly apiZipCode: ZipCodeApiService,
    @Inject(MAT_DIALOG_DATA) public data,
    private readonly fb: FormBuilder,
    private readonly cdRef: ChangeDetectorRef
  ) { }
   ngOnInit() {
    this.dataSourceTable.paginator = this.dataPaginator;
    this.InitializeForms();
    //this.loadData();

    this.listZip =this.data.addlistZip;
    this.listZipToAdd=this.data.addlistZip;
    this.listZip25miles = this.data.listZip25miles;
    this.pageDirectoryData(this.listZip);
    this.updateAddButtonState();
  
  }
  onKeyPress(event: KeyboardEvent): void {
    const allowedChars = /[a-zA-Z0-9 ]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!allowedChars.test(inputChar) && event.key !== 'Backspace' && event.key !== 'Delete') {
      event.preventDefault();
    }
  }
  ngAfterViewInit() {
    this.dataSourceTable.paginator = this.dataPaginator;
    this.dataSourceTable.sort = this.sort;
    //this.listZipSelected = null;
  }


  private InitializeForms(): void {
    // Permit info
    this.formSearch = this.fb.group({
      searchPhrase: ['', [Validators.pattern('^[a-zA-Z0-9 ]*$')]],
      chk25miles: [false]
    });

      }
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSourceTable.data.length;
    this.updateAddButtonState();
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clears selection. */
  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSourceTable.data.forEach(row => this.selection.select(row));
        this.updateAddButtonState();
  }

   updateAddButtonState() {
    this.addButtonDisabled = this.selection.isEmpty(); // selection is the 
   }
   
  private pageDirectoryData(paginateList: IZipCode[]): void {
    if ( Array.isArray(paginateList) && paginateList.length > 0 )
    {
      this.noSearchResults = false;
      this.dataResultsLength = paginateList.length;
      this.dataSourceTable.data = paginateList;
    }
    else {
      this.noSearchResults = true;
    }
      this.waitForListingToShow = false;
    this.cdRef.markForCheck();
  
    
  }
  private sortZipCodesByZip(zipCodes: IZipCode[]): IZipCode[] {
    const length = zipCodes.length;
    for (let i = 0; i < length - 1; i++) {
      for (let j = 0; j < length - i - 1; j++) {
        if (zipCodes[j].name > zipCodes[j + 1].name) {
          // Swap zipCodes[j] and zipCodes[j + 1]
          const temp = zipCodes[j];
          zipCodes[j] = zipCodes[j + 1];
          zipCodes[j + 1] = temp;
        }
      }
    }
    return zipCodes;
  }
  private haversine(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const R = 6371; // Radius of the Earth in kilometers
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a = 
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * 
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c; // Distance in kilometers
  }
  public checkboxLabel(row?: IZipCode): string {
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.name}`;
  }
  getLatLong(zipCode: string): { lat: number, lng: number } {
    const zipLocation = this.listZip.find(z => z.name === zipCode);
    if (zipLocation) {
      return { lat: parseFloat(zipLocation.latitude), lng: parseFloat(zipLocation.longitude) };
    }
    return null;
  }
  getZipCodesWithinRadius(zipCode: string, radius: number = 25): IZipCode[] {
    const centerLocation = this.getLatLong(zipCode);
    if (!centerLocation) return [];

    const radiusInKm = radius * 1.60934; // Convert miles to kilometers

    return this.listZip.filter(location => {
      const distance = this.haversineDistance(centerLocation.lat, centerLocation.lng, parseFloat(location.latitude), parseFloat(location.longitude));
      return distance <= radiusInKm;
    }).map(location => location);
  }
  private haversineDistance(lat1: number, lng1: number, lat2: number, lng2: number): number {
    const toRad = (x: number) => x * Math.PI / 180;
    const R = 6371; // Earth radius in km

    const dLat = toRad(lat2 - lat1);
    const dLng = toRad(lng2 - lng1);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
              Math.sin(dLng / 2) * Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c; // Distance in km
  }
  public onChange25miles(event): void {
    const chekedmiles = event.checked;
    // Reset the search field
  this.formSearch.get('searchPhrase').setValue('');
if(chekedmiles){
  
  this.listZip = this.listZip25miles;

}
else{
  this.listZip = this.listZipToAdd;

}
this.pageDirectoryData(this.listZip);
  }
  public searchZipCodeListByPhrase(phrase: string): void {
    phrase = phrase.trim().toLowerCase();
    this.listSearch = this.listZip.filter((code: IZipCode) => {
      const nameMatch = code.name && code.name.toLowerCase().includes(phrase);
      const cityMatch = code.city && code.city.toLowerCase().includes(phrase);
      const countyMatch = code.county && code.county.toLowerCase().includes(phrase);
      
      return nameMatch || cityMatch || countyMatch;
    });
  
    this.dataSourceTable.data = this.listSearch;
    this.cdRef.markForCheck();
  }


  onClickCancel(): void {
    this.dialogRef.close();
  }

  onClickSave(): void {
    for(let i = 0;  i < this.dataSourceTable.data.length; i++) {
      if (this.selection.isSelected(this.dataSourceTable.data[i])) {
        this.listZipSelected.push(this.dataSourceTable.data[i]);
      }
    }
    this.dialogRef.close(this.listZipSelected);
  }

}
